import { render, staticRenderFns } from "./SurveyForm.vue?vue&type=template&id=8d610328&"
import script from "./SurveyForm.vue?vue&type=script&lang=js&"
export * from "./SurveyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports